import { render, staticRenderFns } from "./DeleteQuestionFromMatchConfirmationDialog.vue?vue&type=template&id=d1a0cf10"
import script from "./DeleteQuestionFromMatchConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteQuestionFromMatchConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports